import { createContext, useContext } from "react";

export interface TenantContextType {
  config: any;
}
const TenantContext = createContext<TenantContextType | undefined>(undefined);

const useTenantContext = () => {
  const context = useContext(TenantContext);

  if (context === undefined) {
    throw new Error("useTenantContext was used outside of its Provider");
  }

  return context;
};

export { TenantContext, useTenantContext };
